import type { Component } from 'vue';
import Button from './Button.vue';
import SimpleButton from './SimpleButton.vue';

export default new Map<string, Component>([
  ['Button', Button],  
  ['SimpleButton', SimpleButton],  
]);



